import React from "react";
import { useParams } from "react-router-dom";
import SidebarAdmin from "../../menu/SidebarAdmin";
import Topbar from "../../menu/Topbar";
import FormularioAddUsuarios from "../../Formulario/FormularioAddUsuarios";
import { useAuth } from "../../auth/AuthContext";
import { isSuperAdmin, normalizeAccessType } from "../../../utils/accessControl";

const AddUsuarios = () => {
  const { id } = useParams();
  const { user } = useAuth();
  const [menuClose, setMenuClose] = React.useState(false);

  const toggleMenu = () => setMenuClose((prev) => !prev);

  const isEdit = Boolean(id);
  const viewerIsSuperAdmin = isSuperAdmin(normalizeAccessType(user?.access_type));

  const pageTitle = isEdit
    ? "Editar usuario"
    : viewerIsSuperAdmin
    ? "Adicionar usuario"
    : "Adicionar licenciado";
  const headerTitle = isEdit
    ? "Editar dados do usuario"
    : viewerIsSuperAdmin
    ? "Dados do usuario"
    : "Dados do licenciado";
  const headerDescription = isEdit
    ? "Atualize as informacoes do usuario e salve novamente."
    : viewerIsSuperAdmin
    ? "Preencha as informacoes principais para criar um novo usuario."
    : "Preencha as informacoes principais para acesso ao painel de licenciado.";

  return (
    <div className="app-container">
      <SidebarAdmin close={menuClose} />

      <main className="main-content">
        <Topbar page={pageTitle} onToggleMenu={toggleMenu} />

        <section className="content">
          <div className="page-header">
            <h2>{headerTitle}</h2>
            <p>{headerDescription}</p>
          </div>

          <div className="card">
            <FormularioAddUsuarios />
          </div>
        </section>
      </main>
    </div>
  );
};

export default AddUsuarios;
